const accessSettings = {

    USER_ROLE_LIST: { name: 'User Role', path: '/user-role-list' },
    ADD_USER_ROLE: { name: 'Add User Role', path: '/create-user-role' },
    UPDATE_USER_ROLE: { name: 'Update User Role', path: '/edit-user-role' },
    DELETE_USER_ROLE: { name: 'Delete User Role', path: '/delete-user-role' },

    MODULE_LIST: { name: 'Module', path: '/module-list' },
    ADD_MODULE: { name: 'Add Module', path: '/create-module' },
    UPDATE_MODULE: { name: 'Update Module', path: '/edit-module' },
    DELETE_MODULE: { name: 'Delete Module', path: '/delete-module' },

    ACTION_LIST: { name: 'Action', path: '/action-list' },
    ADD_ACTION: { name: 'Add Action', path: '/create-action' },
    UPDATE_ACTION: { name: 'Update Action', path: '/edit-action' },
    DELETE_ACTION: { name: 'Delete Action', path: '/delete-action' },

    PERMISSION: { name: 'Permission', path: '/permission' },

    ENTITY_PERMISSION_LIST: { name: 'Entity Permission', path: '/entity-permission-list' },
    ADD_ENTITY_PERMISSION: { name: 'Add Entity Permission', path: '/create-entity-permission' },
    UPDATE_ENTITY_PERMISSION: { name: 'Update Entity Permission', path: '/edit-entity-permission' },
    DELETE_ENTITY_PERMISSION: { name: 'Delete Entity Permission', path: '/delete-entity-permission' },

    GLOBAL_CONTROL: { name: 'Global Control', path: '/global-control' },

    SERVICES: { name: 'Services', path: '/services' },
    GLOBAL_SETTINGS: { name: 'Global Settings', path: '/global-settings' },

    IP_AND_ACCESS: { name: 'IP & Access', path: '/ip-and-access' },
}

export default accessSettings;